import { Injectable } from '@angular/core';
import text from './text.json';

@Injectable({
  providedIn: 'root'
})
export class TextService {
  get(key: keyof typeof text) {
    return text[key];
  }
}
